import { title } from 'process';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Question, Survey } from '../shared/model-service';
import { PopupService } from '../shared/popup-service';
import { SurveyAnswerService } from '../../public-api';

@Component({
  selector: 'app-unique-choice',
  templateUrl: './unique-choice.component.html',
  styleUrls: ['./unique-choice.component.css']
})
export class UniqueChoiceComponent  {

  show :boolean = false;
  @Input() Question: Question;  
  @Input() SurveyBase : Survey


  questiondsIdLinks : number[] = [];
  questions: Question[]= [];
  result: Question;
  timer: any;
  
  response: string = "";
  selectedOptions = [];

  panelOpenState = true;

  popupService : PopupService;
  constructor(private dialog: MatDialog, private surveyService: SurveyAnswerService) {

  }

  ngOnInit(): void {
    this.popupService = new PopupService(this.dialog);

    if(this.Question.result)
    {
      this.treatEditSurvey(this.SurveyBase);
    } 
  }

  sortBy(prop: string) {
    return this.Question.options.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }

  onNgModelChange($event)
  {

    if(this.timer != null ){
     clearTimeout(this.timer)
    }
  
    this.timer = setTimeout(() => {
      this.panelOpenState = false;
    }, 5000); 


    this.SurveyBase.finish = false;
    this.response = $event[0].title
    this.show = true;
    this.questiondsIdLinks = [];
    this.questions = [];
    let option = this.Question?.options.find(x=> x.id == $event[0].id)
    
    this.Question.result = option.title
    
    if (option?.links.length > 0) {

      option?.links.forEach(element => {
        element.questionDestinationId;
        this.questiondsIdLinks.push(element.questionDestinationId);
        
        /** Open popus */
      if(element.popupDestinationId != null )
      {
        this.popupService.openPopupDialog(element.popupDestinationId,this.SurveyBase);
      }

      /**open tip */
      if(element.tipDestinationTipId != null )
      {
        this.popupService.openTipDialog(element.tipDestinationTipId);
      }
      });
      this.questiondsIdLinks.forEach(element => {
        this.result = this.SurveyBase.questions.find(x => x.id == element);
        if (this.result != null) {
          this.questions.push(this.result);
          
        }
      })
      
    }
  }

 treatEditSurvey(survey)
 {
    this.panelOpenState = false;
    this.show = true;
    let optionSelected = this.Question.options.find(x=>x.title == this.Question.result);
    this.selectedOptions = [optionSelected];
    
    this.response =  optionSelected.title;
    optionSelected?.links.forEach(element => {
      element.questionDestinationId;
      this.questiondsIdLinks.push(element.questionDestinationId);
      /** Open popus */
       this.questiondsIdLinks.forEach(element => {
        this.result = this.SurveyBase.questions.find(x => x.id == element);
        if (this.result != null) {
       
          this.questions.push(this.result);
        }
      })
    })
 }
}

